import React from "react";
import './classwork-concept-list.scss';
import SharedThemeCategory from "../../../../shared-storage/category-theme";
import SharedProfile from "../../../../shared-storage/profile";
import SharedStaticText from "../../../../shared-storage/static-text-store";
import HomeworkApi from "../../../apis/homework";
import Loading from "../../common/loading/loading";
import { getThemeImageSource, getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";
import { Constants } from "../../../constants/constants";
import Path from "../../routes/routes-path";
import CwConfirmationModal from "../../common/cw-confirmation-modal/cw-confirmation-modal";
import StandardClassworkViewAnswerScreen from '../standard-classwork-view-answer/standard-classwork-view-answer';
import ExamPrepKitV2Api from "../../../apis/exam-prep-kit-v2";

class ConceptList extends React.Component {

    constructor(props) {
        super(props);

        // this.homeworkId = this.props.meta.homeworkId

        this.theme = SharedThemeCategory.getThemeCategory(1);

        // this.props.navigation.addListener('didFocus', (data) => {
        this.getHomeworkStatus()

        // });

        // this.getUserHomeworkActivities()

        this.staticText = SharedStaticText.getStaticText('homeworkConceptList');
        this.homeworkCardStaticText = SharedStaticText.getStaticText('homeworkCard');
        this.userInfo = SharedProfile.getProfile();
    }

    state = {

        cleared: [],
        notCleared: [],
        notAttepmted: [],
        categoryId: 1,
        completedHomeworkDetail: {
            marks: 0,
            correct: 0,
            inCorrect: 0
        }

    };

    staticText = {};

    isEpkV2 = () => {
        return Boolean(
            this.props.isEpkV2 ||
            this.props.isEPKV2 ||
            this.props.isEpk ||
            this.props.baseLineAssessmentActivityId ||
            this.props.from === 'EXAM_PREP_KIT_V2' ||
            this.props.calledFrom === 'EXAM_PREP_KIT_V2' ||
            this.props.meta?.isEpkV2 ||
            this.props.meta?.baseLineAssessmentActivityId ||
            this.props.meta?.calledFrom === 'EXAM_PREP_KIT_V2' ||
            this.props.meta?.from === 'EXAM_PREP_KIT_V2' ||
            (this.props.delegate && (
                typeof this.props.delegate.goBackToTableOfContents === 'function' ||
                this.props.delegate.params?.baseLineAssessmentActivityId
            ))
        );
    };

    getClearedText = () => {
        if (this.isEpkV2()) {
            return "Cleared Learning Outcomes";
        }
        return this.staticText?.clearedText || "Cleared";
    };

    getNotClearedText = () => {
        if (this.isEpkV2()) {
            return "Not Cleared Learning Outcomes";
        }
        return this.staticText?.notClearedText || "Not Cleared";
    };


    componentDidMount() {
        // BackHandler.addEventListener('hardwareBackPress', this.backhandler);
    }

    // backhandler = () => {
    //     BackHandler.removeEventListener('hardwareBackPress', this.backhandler);
    //     this.props.navigation.navigate('MyHomeworks');
    //     return true
    // }


    getUserHomeworkActivities = () => {

        let payload = {
            homeworkId: this.homeworkId
        }


        HomeworkApi.getUserHomeworkActivities(payload).then((res) => {

            //console.log(res)


            this.setState({ completedHomeworkDetail: res.contents[0], showSelectChapterModal: true })



        }).catch(err => {
            if (err) {
                return;
            }
        })

    }

    getHomeworkStatus = () => {

        let payload = {
            assessmentActivityId: this.props.baseLineAssessmentActivityId
        }

        ExamPrepKitV2Api.getPracticeMoreStatus(payload).then((res) => {
            //console.log(res)
            if (res) {
                let cleared = this.groupByConcept(res.cleared, res.concepts)
                let notCleared = this.groupByConcept(res.notCleared, res.concepts)
                let notAttepmted = this.groupByConcept(res.notAttepmted, res.concepts)
                let contentsToRender = []

                let statusSelected = null
                if (notCleared.length) {
                    // statusSelected = 'NOT_CLEARED'
                    contentsToRender = notCleared
                } else if (cleared.length) {
                    // statusSelected = 'CLEARED'
                    contentsToRender = cleared
                } else if (notAttepmted.length) {
                    // statusSelected = 'NOT_ATTEMPTED'
                    contentsToRender = notAttepmted
                }

                this.setState({
                    cleared,
                    notCleared,
                    notAttepmted,
                    statusSelected,
                    contentsToRender,
                    homeworkId: res.homeworkId
                })
            }
        }).catch(err => {
            if (err) {
                return
            }
        })
    }

    groupByConcept = (nodes, concepts) => {

        let conceptGroup = {}
        let conceptOrdered = []

        for (let i = 0; i < nodes.length; i++) {
            let node = nodes[i]

            if (conceptGroup[node.conceptKey]) {
                conceptGroup[node.conceptKey].push(node)
            } else {
                conceptGroup[node.conceptKey] = [node]
            }
        }

        for (let i = 0; i < concepts.length; i++) {
            let key = concepts[i].key

            if (conceptGroup[key]) {
                conceptOrdered.push({
                    ...concepts[i],
                    nodes: conceptGroup[key]
                })
            }
        }

        return conceptOrdered
    }

    toggleShadow = () => {
        this.setState({ showShadow: !this.state.showShadow })
    }

    navigate = (status, node, concept) => {

        let eloIds = node.elos ? node.elos.map(item => item.id) : [];

        console.log('test')
        // alert('ReAssess')

        let obj = {
            nodeId: node.id,
            status: status,
            homeworkId: this.state.homeworkId,
            chapterKey: node.chapterKey,
            title: node.chapterTitle,
            nodes: concept.nodes,
            categoryThemeId: 1,
            eloIds,
            isTryAgain: true
        }

        this.props.delegate.showStandardHomeworkExperience && this.props.delegate.showStandardHomeworkExperience(obj)

        // this.props.navigation.navigate("StandardHomeworkLearningExperience", {
        //     params: {
        //         nodeId: node.id,
        //         status: status,
        //         homeworkId: this.meta.homeworkId,
        //         chapterKey: node.chapterKey,
        //         title: node.chapterTitle,
        //         nodes: concept.nodes,
        //         categoryThemeId: this.meta.categoryThemeId,
        //         eloIds
        //     }
        // })
    }
    // getColorBasedOnStatus(color) {

    //     switch (color) {

    //         case 'darkGreen':
    //             return Styles.darkGreen;

    //         case 'red':
    //             return Styles.red;

    //         case 'lightGreen':
    //             return Styles.lightGreen;


    //         default:
    //             return Styles.defaultColor;
    //     }
    // }

    toggleLateralMenu = (flag) => {
        this.props.navigation.push('LateralMenu', { params: { backTo: "EloList" } });
    }

    close = () => {
        // this.props.navigation.navigate('MyHomeworks');
        this.props.navigation.goBack()
    }

    selectStatus = (status) => {
        if (status === 'CLEARED') {
            this.setState({ statusSelected: status, contentsToRender: this.state.cleared }, () => { })
        }

        if (status === 'NOT_CLEARED') {
            this.setState({ statusSelected: status, contentsToRender: this.state.notCleared }, () => { })
        }

        if (status === 'NOT_ATTEMPTED') {
            this.setState({ statusSelected: status, contentsToRender: this.state.notAttepmted }, () => { })
        }

    }

    getEloStatusColor = (status) => {
        if (status === 'CLEARED') {
            return (
                "green-circle"
            )
        }
        if (status === 'NOT_CLEARED') {
            return (
                "red-circle"
            )
        }
        if (status === 'NOT_ATTEMPTED') {
            return (
                "gray-circle"
            )
        }

        if (status === 'IN_PROGRESS') {
            return (
                "gray-circle"
            )
        }

    }

    getEloAction = (status, node, concept) => {

        if (status === 'CLEARED') {
            return (
                <div className="custom-button cursor-pointer" style={{ backgroundColor: this.theme[`themeColor`] }}><span onClick={() => this.navigate(status, node, concept)}>{'Practice More'}</span></div>
            )
        }
        if (status === 'NOT_CLEARED') {
            return (
                // <div >
                //     <div className="custom-button cursor-pointer" style={{ backgroundColor: this.theme[`themeColor`] }}><span onClick={() => this.navigate(status, node, concept)} style={{}}>{node.isStart ? this.staticText.startButtonTitle : this.staticText.tryAgainButtonTitle}</span></div>
                // </div>
                <div >
                    <div className="custom-button cursor-pointer" style={{ backgroundColor: this.theme[`themeColor`] }}><span onClick={() => this.navigate(status, node, concept)} style={{}}>{'Practice More'}</span></div>
                </div>
            )
        }
        if (status === 'START') {
            return (

                <div className="custom-button cursor-pointer" style={{ backgroundColor: this.theme[`themeColor`] }} ><span onClick={() => this.navigate(status, node, concept)}>{this.staticText.startButtonTitle}</span></div>

            )
        }

        if (status === 'IN_PROGRESS' || status === Constants.TRY_AGIN_IN_PROGRESS) {
            return (

                <div className="custom-button cursor-pointer" style={{ backgroundColor: this.theme[`themeColor`] }}><span onClick={() => this.navigate(status, node, concept)}>{this.staticText.continueButtonTitle}</span></div>

            )
        }

        if (status === 'LOCKED') {
            return (
                <div className="text-center"><img className="lock-image-size" src={getImageSource(ImageConstants.LOCK_ICON)}></img></div>
            )
        }

    }

    goToHomeScreen() {

        return this.props.delegate?.props.history.replace({ pathname: Path.HOME })
    }

    goToMyClassworkList = () => {

        this.props.hideClassworkConceptListScreen && this.props.hideClassworkConceptListScreen()

        this.props.delegate && this.props.delegate.hideClassworkConceptListScreen && this.props.delegate.hideClassworkConceptListScreen()
    }



    renderBreadcrumb() {
        return (
            <div className='breadcrumb'>
                <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()}>{`Home >`}</span>
                <span className='title-1 cursor-pointer pl-2' onClick={() => this.goToMyClassworkList()}>{`My Homework >`}</span>
                <span className='title-2 pl-2'>{`${this.props.meta.title || this.props.meta.chapterTitle}`}</span>
                {/* <span className='pl-2'>{this.props.selectedItem.chapters ? this.getChapterNames(this.selectedItem?.chapterName) : this.props.selectedItem.chapter} {`>`}</span>
                    <span className='active pl-2'>{this.getDate(this.selectedItem.createdDate)}</span> */}
            </div>
        )
    }

    showCommingSoon() {
        this.setState({ showCommingSoon: true })
    }

    hideCommingSoon() {
        this.setState({ showCommingSoon: false })
    }

    viewAnswers = () => {
        this.setState({
            showViewAnswerScreen: true,
            metaForViewAnswer: {
                categoryThemeId: this.state.completedHomeworkDetail.categoryId,
                title: this.state.completedHomeworkDetail.chapterTitle,
                homeworkId: this.state.completedHomeworkDetail.homeworkId,
                from: "HOMEWORK"
            }
        })
    }

    hideViewAnswer() {
        this.setState({ showViewAnswerScreen: false })
    }




    render() {

        if (this.state.showCommingSoon) {
            return <CwConfirmationModal showInsights={true} hideInsightsModal={() => this.hideCommingSoon()} />
        }

        if (this.state.showViewAnswerScreen) {
            return (
                <StandardClassworkViewAnswerScreen
                    metaForViewAnswer={this.state.metaForViewAnswer}
                    hideViewAnswerScreen={() => this.hideViewAnswer()}
                    delegate={this} />

            )
        }

        let themeBgColor = this.theme['themeColor']

        this.theme = SharedThemeCategory.getThemeCategory(this.props.categoryId)
        let backgroundColor = this.theme[`secondaryColors`][`chapterCardColor`]

        let lgButton = `linear-gradient(#BDFFF5,#BDFFF5)`

        return (
            <>
                <div className="classwork-concept-list container-fluid p-0">

                    <div className="row mr-0 ml-0">
                        <div className="col pl-0 pr-0">
                            {
                                this.state.cleared && this.state.cleared.length ?
                                    <div className="cleared-text">
                                        {this.getClearedText()}
                                    </div>

                                    : <></>
                            }

                            <div>
                                {this.state.cleared && this.state.cleared.length ? this.state.cleared.map((item, index) =>
                                    <div>
                                        <div className="concept-title mt-2 mb-3">{item.title}</div>
                                        {item.nodes.length && item.nodes.map((node, index) =>
                                            <>
                                                {node.elos.length && node.elos.map((elo, eloIndex) =>
                                                    <div className="elo-row row mr-0 ml-0 mb-2">
                                                        <div className="col-10 row flex-row align-items-center  elo">
                                                            <div className="col-1 pr-0">
                                                                <div className={`${this.getEloStatusColor(node.status)}`} />
                                                            </div>
                                                            <div className="elo-title col pl-0">{elo.title}</div>
                                                        </div>
                                                        <div className="col-2 column-width text-center status-button" onClick={() => this.navigate(node.status, node, item)}>{this.getEloAction(node.status, node, item)}</div>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                )
                                    :
                                    <></>}
                            </div>

                            {
                                this.state.notCleared && this.state.notCleared.length ?
                                    <div className="not-cleared-text mt-4">
                                        {this.getNotClearedText()}
                                    </div>

                                    : <></>
                            }

                            <div>
                                {this.state.notCleared && this.state.notCleared.length ? this.state.notCleared.map((item, index) =>
                                    <div>
                                        <div className="concept-title mt-2 mb-3">{item.title}</div>
                                        {item.nodes.length && item.nodes.map((node, index) =>
                                            <>
                                                {node.elos.length && node.elos.map((elo, eloIndex) =>
                                                    <div className="elo-row row mr-0 ml-0 mb-2">
                                                        <div className="col-10 row flex-row align-items-center  elo">
                                                            <div className="col-1 pr-0">
                                                                <div className={`${this.getEloStatusColor(node.status)}`} />
                                                            </div>
                                                            <div className="elo-title col pl-0">{elo.title}</div>
                                                        </div>
                                                        <div className="col-2 column-width text-center status-button" onClick={() => this.navigate(node.status, node, item)}>{this.getEloAction(node.status, node, item)}</div>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                )
                                    :
                                    <></>}
                            </div>

                        </div>
                    </div>

                </div>
                <>
                    {this.state.loading &&
                        <Loading />
                    }
                </>
            </>

        )
    }
}

export default ConceptList